import { render, staticRenderFns } from "./PointBankAnotherlaneForm.vue?vue&type=template&id=8ce99172"
import script from "./PointBankAnotherlaneForm.vue?vue&type=script&lang=js"
export * from "./PointBankAnotherlaneForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports